import { Component, OnInit, Output, ViewChild, Input ,EventEmitter} from '@angular/core';
import { Router, ActivatedRoute, Event, NavigationStart, NavigationEnd, NavigationError } from '@angular/router';
import {ConstantsModule} from 'src/app/common/constants/constants.module';
import { Group } from '../gis/mapcontrol/group';
import * as FileSaver from 'file-saver';
import {Groupgeojson} from '../gis/mapcontrol/groupgeojson';
import {Layer} from '../gis/mapcontrol/layer';
import {GisComponent} from '../gis/gis.component'
import { UtilsModule } from 'src/app/common/utils/utils.module'
import { GisService } from 'src/app/services/gis/gis.service';
import { SubmitdataService } from 'src/app/services/submitdata/submitdata.service';
import { isNullOrUndefined } from 'util';

import { TranslateService } from '@ngx-translate/core';
import { AuthloginService } from 'src/app/services/login/authlogin.service';
import { EncdecService } from 'src/app/services/encdec.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
  @Input() groupList: Group[];
  @Input() mobileDevice:boolean;
  @Input() activeLayers: Object;
  @Input() activeBaseLayer: Object;
  @Input() baseLayers: Layer[];
  @Input() currentZoomLevel: number;
  @Output() resetAreaEvent = new EventEmitter();
  @Output() selectedId = new EventEmitter<Object>();
  public model: any;
  form: any;
  stateList: [];
  datasubmitted = 'districtwise';
  districtselect: any = undefined;
  basinList: [];
  placeholder: string = 'select ' ;
  selectedstate  = null
  parentLocation: string;
  selectedComponent: string;
  datasubmit = 'statewise';
  layerBoxActiveTab = "overlays";
  activetab = "";
  sidePanel: string;
  selectedistrict :any;
  dashboardView: string = "ADMIN";
  dashboardViewToggle: boolean = false;
  sidebarComponent: any;
  modalRef: any;
  monthselectedmodel:object ={month : "",year:''}
  contentEditable:boolean;
  private GWStation:string = "GW Stations";
  myVar1 =true;
  backApp:boolean = true;
  userdetails;
  userDetails = {};
  userUUID;
  selectedHeader;
  selectedView =this.constants.VIEWS.ADMIN ;
  sidebarView = this.constants.VIEWS.ADMIN;
  preView = this.constants.VIEWS.ADMIN;
  Urlparams;
  userType;
  DistrictList: any[];
  userName;
  filterOptions = {year:'',month:''};
  fieldlist : object = {'montharray' :''};
  validation : object = {month:true,year:true,state:true,district:true}
 Default :object = {assesmentyear:'2016-2017',state :'',district :'',month:''}
 filterDropDownList : object = {AssesmentYearList:[],StateList:[],districtList:[]};
 dropdownSettings: any = {
  singleSelection: false,
  idField: 'item_id',
  textField: 'item_text',
  selectAllText: 'Select All',
  unSelectAllText: 'UnSelect All',
  noDataAvailablePlaceholderText: 'No locations available.',
  itemsShowLimit: 1,
  allowSearchFilter: true
};
monthList:any = [
  { key: '04' ,value: 'April'},
  { key: '05' ,value:'May'},
  { key: '06' ,value: 'June'},
  { key: '07' ,value:'July'},
  { key: '08' ,value: 'August'},
  { key: '09' ,value:'September'},
  { key: '10' ,value: 'October'},
  { key: '11' ,value:'November'},
  { key: '12' ,value: 'December'},
  { key: '01' ,value:'January'},
  { key: '02' ,value: 'February'},
  { key: '03' ,value:'March'},
];
dropdownSetting: any = {
  singleSelection: false,
  idField: 'uuid',
  textField: 'name',
  selectAllText: 'Select All',
  unSelectAllText: 'UnSelect All',
  noDataAvailablePlaceholderText: 'No locations available.',
  itemsShowLimit: 1,
  allowSearchFilter: true
};

  radioselect;
  districtarray: any[];
  districtflag: boolean;
  showDropdown: boolean;
  monthsList: any;
  selectedMonth: any;
  stateArrayList: any[];
  statelists: any[];
  districtentityList: any[];
  showdistdrop: boolean;
  filterdistrict: any;
  yearDropDownList: any;
  loginDetail: any;
  adminManualPdf: boolean = false;
  showvideoButton: boolean;
  showuserManual: boolean;
  // selectedId: any;
  constructor(
    public constants : ConstantsModule,
    public mapComponent : GisComponent,
    public utils : UtilsModule,
    public route : ActivatedRoute,
    public router : Router,
    public gisService : GisService,
    private sessionlogin : AuthloginService,
    private encdecservice : EncdecService,
    private translate: TranslateService,
    private submitdataservice : SubmitdataService
    ){
      translate.setDefaultLang('en');
      this.router.events.subscribe((event: Event) => {
        if (event instanceof NavigationStart) {
  
          // Show loading indicator
        }
  
        if (event instanceof NavigationEnd) {
          this.initializeOnStateLoad(event);
        }
  
        if (event instanceof NavigationError) {
        }
      });
  }
  ngOnInit() {
    this.getAssesmentYear();
    this.radioselect = "STATES_PERFORMING";
    this.monthsList = this.monthList;
    this.getstateslist();
    this.userDetails = this.sessionlogin.checkloginstatus();
    if(this.userDetails!=null && this.userDetails!=undefined){
      this.showuserManual = true
    } else{
      this.showuserManual = false;
    }
    this.getLoginUser(this.userDetails)
    this.setCurrentMonthDefault();
    
  }
  getLoginUser(user){
    if(user!=null && user!=undefined){
      if(user['roles'][0] == "STATE_GANGA_COMMITTEE" || user['roles'][0] == "ADMIN"){
        this.adminManualPdf = true;
      } else{
        this.adminManualPdf = false;
      }
    }
  }
  getAssesmentYear(){
    let date = new Date();
    let currentYear = date.getFullYear();
    let currentmonth = date.getMonth();
    let dropDownYear;
    if(currentmonth <3){
      dropDownYear = (currentYear - 1) + '-'+ currentYear;
    } else{
      dropDownYear = currentYear + '-'+ (currentYear + 1);
    }
    this.submitdataservice.getYearsToDisplay(this.submitdataservice.yearsPayload).subscribe(data=>{
      this.yearDropDownList = data['data'];
    });    this.filterOptions['assesmentyear'] = dropDownYear;
  }
  initializeOnStateLoad(event: object): void {
    
    if(this.userdetails){
      this.userType= this.userdetails['loggedUserData']['userProfile']['associatedlocationsDetails']['0']['entityType'];
      this.userName= this.userdetails['loggedUserData']['userProfile']['associatedlocationsDetails']['0']['entityName'];
      
    }
    if (event['url'].indexOf("report") >= 0) return;

    this.parentLocation = this.route.snapshot.paramMap.get('parentLocName');
    let component = this.route.snapshot.paramMap.get('component');

    let tempUrl = this.utils.getWritableObject(this.route.snapshot.params);
    
  }
  public AddDefaultUrlParams(){
    // this.setCurrentMonthDefault();
    this.Urlparams = this.utils.getWritableObject(this.route.snapshot.params);
    if(this.Urlparams['parentLocName']=='') return;
    // this.filterDropDownList["AssesmentYearList"] = this.gisService.getassesmentYear();
    // this.Default['assesmentyear'] = this.filterDropDownList['AssesmentYearList'][this.filterDropDownList['AssesmentYearList'].length-1]
    // this.setyear(this.Urlparams['assesmentyear']);
    // this.setstate(this.Urlparams['district']);
    this.setdist(this.Urlparams['district'])
    this.setmonth(this.Urlparams['month']);
    // this.setComponent(this.Urlparams['component']);
    let urlParams = {}
    // let rpHM ={"mapOnClickParams":"false"};
    // urlParams = Object.assign(urlParams,rpHM);
    this.Urlparams["mapOnClickParams"] = false;
    urlParams = Object.assign(this.Urlparams);
    
    this.router.navigate(["/gis", this.constants.DEFAULT_COUNTRY, urlParams]);
  }
  // private setyear(year){
    
  //   this.filterOptions['assesmentyear'] = year || this.Default['assesmentyear']
  // }
  private setmonth(month){
    this.filterOptions['month'] = month || this.Default['month'];
  }
  selectOption(month){
    this.selectedMonth = month;
    this.selectedId.emit(this.selectedMonth);
  }
  private setstate(state){
    
    let statearray = [];
    // if(state){
    //   statearray = this.gisService.convertKeysto(state.split(','),"aot",this.filterDropDownList['StateList'],'statewise')
    // }
    this.filterOptions['statearray'] =  statearray || this.Default['state'];
    if(this.datasubmit == 'districtwise'){
      this.filterOptions['statearray'] = this.districtarray;
    }
  }
  private setdist(district){
    
    let distobj = [];
    if(district){
      distobj = this.gisService.convertdata(district.split(','),"aot",this.filterDropDownList['districtList'])
    }
    this.filterOptions['statearray'] =  distobj || this.Default['district']
  }
  setCurrentMonthDefault(){
    let currentmonth = new Date().getMonth()
    let currentmonthObj;
    this.monthsList.forEach(monthObj =>{
      if(parseInt(monthObj['key'])  == currentmonth + 1){
        currentmonthObj = monthObj;
      }
    });
    this.filterOptions['month'] = currentmonthObj['key'];
  }
  
  activatesidemanu(addid,removeid1,removeid2,activetype?) {
    document.getElementById(removeid1.toString()).style.display = 'none';
    document.getElementById(removeid2.toString()).style.display = 'none';
    this.activetab = activetype;
    let body = document.getElementById(addid.toString());
    if(body.style.display === 'none'){
      body.style.display = 'block';
    }else{
      body.style.display = 'none';
    }
  }
  setLayerBoxActiveTab(tab: string): void {
    this.layerBoxActiveTab = tab;
  }
  removeSideMenu(removeid){
    document.getElementById(removeid.toString()).style.display = 'none';
  }
  dataSubmissionChange(){
  }
  setSelectedComponent(component: string,waterquality?:string): void {
    let existingUrlParams = this.utils.getWritableObject(this.route.snapshot.params);
    existingUrlParams['component'] = component;
    this.router.navigate(["/gis", existingUrlParams]);
  }
  // submitfilter(){
  //   let urlParams = { }
  //   let statearray = [];
  //   if(this.filterOptions['statearray'].length > 0 && this.datasubmit == 'statewise'){
  //     statearray = this.gisService.convertKeysto(this.filterOptions['statearray'],"ota",[],'statewise')
  //   }
  //    urlParams = Object.assign(this.Urlparams,this.filterOptions);
  //    if(this.datasubmit == 'statewise'){
  //     urlParams['state'] = statearray;
  //    } else{
  //     let districtarray = this.gisService.convertKeysto(this.districtarray,"ota",[],'districtwise');
  //      urlParams['state'] = districtarray;
  //      urlParams['statearray'] = this.districtarray
  //    }
  //    this.router.navigate(["/gis",this.constants.DEFAULT_COUNTRY, urlParams]);
  // }
  submitdatafilter(){
    if(this.validationCheck()){
      let urlParams = {};
      let statearray = [];
      if(this.districtarray&&this.districtarray.length > 0){
        this.districtarray.splice(-1,1);
        statearray = this.gisService.convertdata(this.districtarray,"ota",[]);
      }
      //  if(!isNullOrUndefined(urlParams)){
        urlParams = Object.assign(this.Urlparams,this.filterOptions);
        urlParams['district'] = statearray
        this.router.navigate(["/gis",this.constants.DEFAULT_COUNTRY, urlParams]);
      //  }
    } 
  }
  getLocationList(){
    let option = {};
    option['pType'] = this.constants.LOCATION_CONSTANT['REGION'];
    option['cType'] = this.constants.LOCATION_CONSTANT['STATE'];
    option["component"] = "";
    option["src"] = "";
    this.submitdataservice.getLocationList(option).subscribe(data =>{
      if(data){
        let statearray = [];
        Object.keys(data).forEach((key) => {
          data[key].forEach(list => {
            statearray.push(list);
            this.filterDropDownList['StateList'] = this.formatListForMultiDropDown(statearray);
          });
        });
        this.AddDefaultUrlParams()
      }
      else
       this.filterDropDownList['StateList'] = [];
      // this.activeSpinner = false;
  },function(err){
      this.activeSpinner = false;
      if(err['error']){
        this.toastr.error(err['error']['msg'])
      }
    });
  }
  formatListForMultiDropDown(data:any): any{
    let result = [];
      for(let i = 0; i < data.length; i++){
        if(!data[i]) continue;
        let item = {};
        item['item_id'] = data[i]['uuid'];//id++;
        item['item_text'] = data[i]['name'];
        result.push(item);
      }
      result.sort((a, b) => (a.item_text > b.item_text) ? 1 : -1);
    return result;
  }
  onItemSelect(item: any) {
    this.addItem(item,'');
  }
  onItemDeSelect(item: any) {
    this.removeItem(item,'');
  }
  onItemDeSelectAll(items: any) {
    this.removeItem(items,'all');
  }
  onSelectAll(items: any) {
    this.addItem(items,'all');
  }
  addItem(item,option){
    if(option == 'all'){
     this.filterOptions['statearray'] = [];
    }
    for(let i=0; i<item.length;i++){
    this.filterOptions['statearray'].push(item[i]);
    }
  }
  getLocationForDistrict(stateuuid){
    this.districtselect = stateuuid;
    this.DistrictList = [];
    let option = {
      'pType':this.constants.LOCATION_CONSTANT['STATE'],
      'cType':this.constants.LOCATION_CONSTANT['DISTRICT'],
      'puuid': (stateuuid != 'null' ? stateuuid : null)
    };
    this.submitdataservice.getLocationListforUser(option).subscribe(data =>{
      if(Array.isArray(data)){
        this.DistrictList = data;
      }
     
  },function(err){
      this.activespineer = false;
      if(err['error']){
        this.toastr.error(err['error']['msg'])
      }
    })
  }
  removeItem(item,option){
    if(option == 'all'){
      this.filterOptions['statearray'] = [];
     }else{
    for(let i=0; i<this.filterOptions['statearray'].length;i++){
      for(let j=0; j<item.length;j++){
       if(this.filterOptions['statearray'][i]['item_id'] == item[j]['item_id']){
        this.filterOptions['statearray'].splice(i, 1)
       }
      }
    }
  }
  }
  typechanged(){
    if(this.datasubmit == 'statewise'){
     this.showDropdown = false;
    } else  {
      this.showDropdown = true;
    }
  }
  onItemSelects(item: any) {
    this.addItems(item,'');
  }
  onItemDeSelects(item: any) {
    this.removeItems(item,'');
  }
  onItemDeSelectAlls(items: any) {
    this.removeItems(items,'all');
  }
  onSelectAlls(items: any) {
    this.addItems(items,'all');
  }
  addItems(item,option){
    if(option == 'all'){
     this.districtarray = [];
    }
    if( this.datasubmitted == 'districtwise' ){
      this.districtarray.push(item);
    } else{
      for(let i=0; i<item.length;i++){
        this.districtarray.push(item[i]);
  }
    }
  }
  removeItems(item,option){
    if(option == 'all'){
      this.districtarray = [];
     }else{
    for(let i=0; i<this.districtarray.length;i++){
      for(let j=0; j<item.length;j++){
       if(this.districtarray[i]['uuid'] == item[j]['uuid']){
        this.districtarray.splice(i, 1)
       }
      }
    }
  }
  }
  getstateslist(){
    let postdata = {};
    this.stateArrayList = [];
    this.statelists = [];
    postdata['pType'] = this.constants.LOCATION_CONSTANT['BASIN'];
    postdata['cType'] = this.constants.LOCATION_CONSTANT['STATE'];
    postdata["component"] = "";
    postdata["src"] = "";
    this.submitdataservice.getLocationList(postdata).subscribe(data =>{
      if(data){
         this.statelists = [];
           Object.keys(data).forEach(key =>{
          data[key].forEach(statelist => {
            this.statelists.push(statelist);
            this.statelists.sort((a, b) => (a.name > b.name) ? 1 : -1);
            // this.filterDropDownLists['GroupList'] = this.groupListForMultiDropDown(this.statelists,true);

          });
        })
      }
    });
    this.AddDefaultUrlParams();
  
  }
  showdistrictdropdown(stateuuid){
    this.filterdistrict = stateuuid;
    if(stateuuid){
      this.showdistdrop = true;
    } else{
      this.showdistdrop = false;
    }
    if(this.showdistdrop){
      this.getDistrictList();
    }
    this.selectedId.emit(stateuuid)
  }
  pdfDownload(){
   let pdfName = "AuthorityNotification.pdf";
   let pdfUrl = './assets/report/47_AuthorityNotification.pdf'
   FileSaver.saveAs(pdfUrl,pdfName);
  }
  userManualDownload(){
    let pdfname = "GDPMS User Manual.pdf"
    let userUrl = "./assets/report/Updated_User_Manual_GDPMS_for_DGC.pdf"
    FileSaver.saveAs(userUrl,pdfname);
  }
  adminManualDownload(){
    let pdfName = "Admin User Manual.pdf";
    let adminPdfUrl = './assets/report/Updated_User_Manual_for_SGC_and_NMCG.pdf';
    FileSaver.saveAs(adminPdfUrl,pdfName);
    console.log("userdet",this.userdetails);

  }
  dgchindiManual(){
      let manual = "DGC User Manual Hindi.docx"
      let userUrl = "./assets/report/DGChindi.docx"
      FileSaver.saveAs(userUrl,manual)
   }
    dgcenglishManual(){
      let manual = "DGC User Manual English.docx"
      let userUrl = "./assets/report/DGCenglish.docx"
      FileSaver.saveAs(userUrl,manual)
    }
  getDistrictList(){
    this.filterDropDownList['districtList'] = [];
    this.selectedistrict = null;
    // this.selectdistrict = undefined;
    let postdata = {
      'pType':this.constants.LOCATION_CONSTANT['STATE'],
      'cType':this.constants.LOCATION_CONSTANT['DISTRICT'],
      'puuid': this.filterdistrict
    }
    this.submitdataservice.getLocationListforUser(postdata).subscribe(data =>{
      if(Array.isArray(data)){
        this.filterDropDownList['districtList'] = data;
      }
     
  },function(err){
      this.activespineer = false;
      if(err['error']){
        this.toastr.error(err['error']['msg'])
      }
    })
  }
  validationCheck(){
    if(this.utils.checkfield(this.filterOptions['assesmentyear'])){
      this.validation['year'] = true;
    }else{
      this.validation['year'] = false;
    }

    if(this.utils.checkfield(this.filterOptions['month'])){
      this.validation['month'] = true;
    }else{
      this.validation['month'] = false;
    }
    if(this.utils.checkfield(this.selectedstate)){
      this.validation['state'] = true;
    } else{
      this.validation['state'] = false;
    }
    if(this.utils.checkfield(this.showdistdrop && this.districtarray)){
      this.validation['district'] = true;
    } else{
      this.validation['district'] = false;
    }
    return this.validation['year'] && this.validation['month'] && this.validation['state'] && this.validation['district']
  }
}
  